package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.zIndex
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.section.HeaderTopBar
import devxertech.com.section.SideBar
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import kotlinx.browser.document
import androidx.compose.runtime.NoLiveLiterals
import org.w3c.dom.events.EventListener
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Video

@Composable
fun HomePageHeader(
    breakpoint: Breakpoint,
    headingText: String,
    descriptionText: String,
    descriptionTextAddition: String,
    startProject: Boolean = true,
    showExtraText: Boolean = true,
    mainHeadingAsH1: Boolean = false,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()
    var isSideMenuOpen by remember { mutableStateOf(false) }
    var isButtonHovered by remember { mutableStateOf(false) }

    if (isSideMenuOpen || breakpoint < Breakpoint.XL) {
        SideBar(breakpoint = breakpoint, isOpen = isSideMenuOpen, onClose = { isSideMenuOpen = false }, showExtraText = true)
    }
    Box(
        modifier = Modifier.fillMaxWidth()
            .height(100.vh)
            .position(Position.Relative)
    )
    {
        BackgroundVideo()
        Column(
            modifier = Modifier.fillMaxSize().zIndex(5)
        ) {
            HeaderTopBar(
                breakpoint,
                onMenuClick = { isSideMenuOpen = true },
                showExtraText,
                isServiceHeader = true,
            )
            Row(
                modifier = Modifier.fillMaxSize()
                    .padding(
                        leftRight = if (breakpoint <= Breakpoint.MD) 30.px else 122.px,
                        top = when {
                            else -> if (breakpoint < Breakpoint.MD) 50.px else 20.px
                        }
                    )
                    .flexWrap(if (breakpoint < Breakpoint.MD) FlexWrap.Wrap else FlexWrap.Nowrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (breakpoint >= Breakpoint.MD) Arrangement.SpaceAround else Arrangement.Center
            ) {
                if (breakpoint > Breakpoint.MD) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center
                    ) {
                        HomeHeadingContainer(
                            asH1 = mainHeadingAsH1,
                            modifier = Modifier
                                .textAlign(if (window.screen.width > 1400) TextAlign.Center else TextAlign.Start)
                                .width(
                                    when {
                                        window.screen.width < 400 -> 300.px
                                        window.screen.width in 400..1269 -> 400.px
                                        window.screen.width in 1270..1600 -> 800.px
                                        else -> 900.px
                                    }
                                )
                        ) {
                            FieldTitleTextNormalSimple(
                                text = headingText,
                                color = sitePalette.bodyBackgroundSecondary.rgb,
                                fontSize = when {
                                    window.screen.width > 1600 -> 50.px
                                    window.screen.width in 1270..1599 -> 48.px
                                    else -> 30.px
                                },
                                fontWeight = 600,
                                lineHeight = if (breakpoint <= Breakpoint.LG) 40.px else
                                    if (window.screen.width > 1600) 55.px else 60.px,
                                whiteSpace = WhiteSpace.PreWrap
                            )
                        }
                        Span(
                            attrs = Modifier.margin(topBottom = 5.px)
                                .textAlign(if (window.screen.width > 1400) TextAlign.Center else TextAlign.Start)
                                .width(
                                    when {
                                        window.screen.width < 400 -> 300.px
                                        window.screen.width in 400..1269 -> 400.px
                                        window.screen.width in 1270..1600 -> 830.px
                                        else -> 900.px
                                    }
                                )
                                .toAttrs()
                        )
                        {
                            FieldTitleTextNormalSimple(
                                text = descriptionText,
                                color = sitePalette.bodyBackgroundSecondary.rgb,
                                fontSize = when {
                                    window.screen.width > 1600 -> 22.px
                                    window.screen.width in 900..1269 -> 20.px
                                    breakpoint >= Breakpoint.MD -> 20.px
                                    else -> 16.px
                                },
                                fontWeight = 500,
                                marginBottom = 20.px,
                                whiteSpace = WhiteSpace.PreWrap
                            )
                        }
                        Span(
                            attrs = Modifier.margin(
                                top = if (breakpoint <= Breakpoint.MD) (-4).px else 0.px,
                                bottom = 10.px
                            )
                                .textAlign(if (window.screen.width >= 1300) TextAlign.Center else TextAlign.Start)
                                .width(
                                    when {
                                        window.screen.width < 400 -> 300.px
                                        window.screen.width in 400..1269 -> 400.px
                                        window.screen.width in 1270..1600 -> 830.px
                                        else -> 900.px
                                    }
                                )
                                .toAttrs()
                        )
                        {
                            FieldTitleTextNormalSimple(
                                text = descriptionTextAddition,
                                color = sitePalette.bodyBackgroundSecondary.rgb,
                                fontSize = when {
                                    window.screen.width > 1600 -> 22.px
                                    window.screen.width in 900..1269 -> 20.px
                                    breakpoint >= Breakpoint.MD -> 20.px
                                    else -> 16.px
                                },
                                fontWeight = 500,
                                marginBottom = 20.px,
                                whiteSpace = WhiteSpace.PreWrap
                            )
                        }
                        if (startProject) {
                            Box(
                                modifier = Modifier
                                    .width(170.px)
                                    .height(42.px)
                                    .borderRadius(6.px)
                                    .onClick { ctx.router.navigateTo("/contact-us") }
                                    .cursor(Cursor.Pointer)
                                    .onMouseEnter { isButtonHovered = true }
                                    .onMouseLeave { isButtonHovered = false }
                                    .margin(top = if (breakpoint <= Breakpoint.MD) 30.px else 0.px)
                                    .position(Position.Relative)
                                    .display(DisplayStyle.Flex)
                                    .justifyContent(JustifyContent.Center)
                                    .backgroundColor(if (isButtonHovered) sitePalette.bodyBackgroundSecondary.rgb else Colors.White)
                                    .styleModifier {
                                        property("color", "white")
                                        property("align-items", "center")
                                    }
                            ) {
                                // Overlay Box like ::before
                                Box(
                                    modifier = Modifier
                                        .fillMaxSize()
                                        .position(Position.Absolute)
                                        .top(0.px)
                                        .left(0.px)
                                        .borderRadius(6.px)
                                        .backgroundColor(if (isButtonHovered) sitePalette.primary.rgb else sitePalette.commonSecondaryButtonColor.rgb)
                                        .zIndex(0)
                                        .styleModifier {
                                            property("will-change", "clip-path")
                                            property(
                                                "transition",
                                                "clip-path 0.2s ease-in-out, opacity 0.1s ease-in-out"
                                            )
                                            property("opacity", if (isButtonHovered) "1" else "0.999")
                                            property(
                                                "clip-path",
                                                if (isButtonHovered)
                                                    "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)"
                                                else
                                                    "polygon(98% 98%, 99% 98%, 99% 99%, 98% 99%)"
                                            )
                                        }
                                )
                                Box(
                                    modifier = Modifier
                                        .size(12.px)
                                        .position(Position.Absolute)
                                        .bottom(0.px)
                                        .right(0.px)
                                        .borderRadius(2.px)
                                        .backgroundColor(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.primary.rgb)
                                        .transform {
                                            translateX(5.5.px)
                                            translateY(5.px)
                                        }
                                        .zIndex(10)
                                        .styleModifier {
                                            property("opacity", if (isButtonHovered) "0" else "1")
                                            property("transition", "opacity 0.0s ease")
                                        }
                                )


                                SpanText(
                                    text = "Start A Project",
                                    modifier = Modifier
                                        .fontFamily(Constants.FONT_FAMILY)
                                        .fontSize(17.px)
                                        .letterSpacing(0.3.px)
                                        .fontWeight(500)
                                        .color(if (isButtonHovered) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
                                        .zIndex(1)
                                )
                            }
                        }
                    }
                }
                    else {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center
                    ) {
                        val mobileHeading: @Composable () -> Unit = {
                            Span(
                                attrs = Modifier
                                    .textAlign(TextAlign.Center)
                                    .width(95.percent)
                                    .toAttrs()
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = "Think Big",
                                    color = sitePalette.bodyBackgroundSecondary.rgb,
                                    fontSize = 33.px,
                                    fontWeight = 600,
                                    lineHeight = 40.px,
                                    whiteSpace = WhiteSpace.PreWrap
                                )
                            }
                            if (mainHeadingAsH1) Text(" ")
                            Span(
                                attrs = Modifier
                                    .textAlign(TextAlign.Center)
                                    .width(95.percent)
                                    .toAttrs()
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = "We Make it Possible!",
                                    color = sitePalette.bodyBackgroundSecondary.rgb,
                                    fontSize = 30.px,
                                    fontWeight = 600,
                                    lineHeight = 40.px,
                                    whiteSpace = WhiteSpace.PreWrap
                                )
                            }
                        }
                        if (mainHeadingAsH1) {
                            HomeHeadingContainer(
                                asH1 = true,
                                modifier = Modifier.fillMaxWidth().styleModifier {
                                    property("display", "flex")
                                    property("flex-direction", "column")
                                    property("align-items", "center")
                                }
                            ) { mobileHeading() }
                        } else {
                            mobileHeading()
                        }
                        Span(
                            attrs = Modifier.margin(topBottom = 5.px)
                                .textAlign(TextAlign.Justify)
                                .width(95.percent)
                                .toAttrs()
                        )
                        {
                            FieldTitleTextNormalSimple(
                                text = "Your Ideas will get their desired form- Website, Mobile app or" +
                                        " anything Technical, let Devxer Technologies lead the way",
                                color = sitePalette.bodyBackgroundSecondary.rgb,
                                fontSize = 16.px,
                                fontWeight = 500,
                                marginBottom = 20.px,
                                whiteSpace = WhiteSpace.PreWrap
                            )
                        }
                        if (startProject) {
                            Box(
                                modifier = Modifier
                                    .width(170.px)
                                    .height(42.px)
                                    .borderRadius(6.px)
                                    .onClick { ctx.router.navigateTo("/contact-us") }
                                    .cursor(Cursor.Pointer)
                                    .onMouseEnter { isButtonHovered = true }
                                    .onMouseLeave { isButtonHovered = false }
                                    .margin(top = if (breakpoint <= Breakpoint.MD) 30.px else 0.px)
                                    .position(Position.Relative)
                                    .display(DisplayStyle.Flex)
                                    .justifyContent(JustifyContent.Center)
                                    .backgroundColor(if (isButtonHovered) sitePalette.bodyBackgroundSecondary.rgb else Colors.White)
                                    .styleModifier {
                                        property("color", "white")
                                        property("align-items", "center")
                                    }
                            ) {
                                // Overlay Box like ::before
                                Box(
                                    modifier = Modifier
                                        .fillMaxSize()
                                        .position(Position.Absolute)
                                        .top(0.px)
                                        .left(0.px)
                                        .borderRadius(6.px)
                                        .backgroundColor(if (isButtonHovered) sitePalette.primary.rgb else sitePalette.commonSecondaryButtonColor.rgb)
                                        .zIndex(0)
                                        .styleModifier {
                                            property("will-change", "clip-path")
                                            property(
                                                "transition",
                                                "clip-path 0.2s ease-in-out, opacity 0.1s ease-in-out"
                                            )
                                            property("opacity", if (isButtonHovered) "1" else "0.999")
                                            property(
                                                "clip-path",
                                                if (isButtonHovered)
                                                    "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)"
                                                else
                                                    "polygon(98% 98%, 99% 98%, 99% 99%, 98% 99%)"
                                            )
                                        }
                                )
                                Box(
                                    modifier = Modifier
                                        .size(12.px)
                                        .position(Position.Absolute)
                                        .bottom(0.px)
                                        .right(0.px)
                                        .borderRadius(2.px)
                                        .backgroundColor(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.primary.rgb)
                                        .transform {
                                            translateX(5.5.px)
                                            translateY(5.px)
                                        }
                                        .zIndex(10)
                                        .styleModifier {
                                            property("opacity", if (isButtonHovered) "0" else "1")
                                            property("transition", "opacity 0.0s ease")
                                        }
                                )


                                SpanText(
                                    text = "Start A Project",
                                    modifier = Modifier
                                        .fontFamily(Constants.FONT_FAMILY)
                                        .fontSize(17.px)
                                        .letterSpacing(0.3.px)
                                        .fontWeight(500)
                                        .color(if (isButtonHovered) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
                                        .zIndex(1)
                                )
                            }
                        }
                    }

                }
            }
        }
    }
}

@Composable
@NoLiveLiterals
fun BackgroundVideo() {
    Video(
        attrs = {
            attr("muted", "")
            attr("loop", "")
            attr("playsinline", "")
            attr("preload", "none")
            attr("poster", "/homepage-video-poster.webp")
            attr("width", "1920")
            attr("height", "1080")
            attr("aria-hidden", "true")
            attr("data-home-background-video", "")
            // Export a poster-only element. The parser must not start a video
            // that Kobweb will discard when it recreates the exported root.
            ref { element ->
                var visible = true
                val exporting = window.location.search.contains("_kobwebIsExporting=true")
                fun updatePlayback() {
                    if (exporting || !visible || (document.asDynamic().hidden as Boolean)) element.pause()
                    else {
                        if (element.getAttribute("src") == null) element.src = "/${Res.Video.header_one_video}"
                        element.muted = true
                        element.play().catch { Unit }
                    }
                }
                val observerCallback: (dynamic) -> Unit = { entries ->
                    visible = entries[0].isIntersecting as Boolean
                    updatePlayback()
                }
                val observer: dynamic = js("new IntersectionObserver(observerCallback)")
                observer.observe(element)
                val visibilityListener = EventListener { updatePlayback() }
                document.addEventListener("visibilitychange", visibilityListener)
                onDispose {
                    observer.disconnect()
                    document.removeEventListener("visibilitychange", visibilityListener)
                    element.pause()
                    element.removeAttribute("src")
                    element.load()
                }
            }

            style {
                position(Position.Absolute)
                top(0.px)
                left(0.px)
                width(100.percent)
                height(100.percent)
                property("object-fit", "cover")
                zIndex(1)  // Behind your content (content is at zIndex(2))
            }
        }
    )
}
@Composable
private fun HomeHeadingContainer(
    asH1: Boolean,
    modifier: Modifier,
    content: @Composable () -> Unit
) {
    if (asH1) {
        H1(attrs = Modifier.margin(0.px).padding(0.px).styleModifier {
            property("font-size", "inherit")
            property("font-weight", "inherit")
            property("line-height", "inherit")
            property("display", "inline")
        }.then(modifier).toAttrs()) { content() }
    } else {
        Span(attrs = modifier.toAttrs()) { content() }
    }
}
